import React from 'react';

export function BrandLogo({navigation=false}){
  return <span className="brand-lockup"><img src="/brand/birajfond-mark.svg" width="38" height="38" alt=""/><span className="brand-wordgroup"><span className="brand-name">Biraj<span>Fond</span></span>{navigation&&<span className="brand-caption">Odaberi fond</span>}</span></span>;
}
